/**
 * CommentInfo Remapper
 * Flutter source: lib/data/models/comment_info.dart
 *
 * `highlightParentComment` is a UI-only flag — not serialized in either direction.
 */

import type { CommentInfoDto } from '@/data/dtos/info/commentInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { CommentInfoEntity } from '@/domain/entities/comment/commentInfoEntity';

export class CommentInfoRemapper {
  static fromJson(data: JsonObject): CommentInfoDto {
    return {
      id: (data['id'] as string | undefined) || '',
      replyId: (data['replyId'] as string | null | undefined) ?? null,
      parentId: (data['parentId'] as string | null | undefined) ?? null,
    };
  }

  static fromJsonList(dataList: JsonObject[]): CommentInfoDto[] {
    return dataList.map(CommentInfoRemapper.fromJson);
  }

  static toJson(dto: CommentInfoDto): JsonObject {
    return {
      id: dto.id,
      replyId: dto.replyId,
      parentId: dto.parentId,
    };
  }

  static fromDto(dto: CommentInfoDto): CommentInfoEntity {
    return {
      id: dto.id,
      replyId: dto.replyId ?? undefined,
      parentId: dto.parentId ?? undefined,
    };
  }

  static toDto(entity: CommentInfoEntity): CommentInfoDto {
    return {
      id: entity.id,
      replyId: entity.replyId ?? null,
      parentId: entity.parentId ?? null,
    };
  }
}
